import React from "react";
import cx from "classnames";
import SpaceBetween from "../SpaceBetween";
import styles from "./Card.module.scss";

export interface CardHeaderProps {
  className?: string;
  actions?: React.ReactNode;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ className, children, actions }) => {
  return (
    <div className={cx(styles.cardHeader, className)}>
      <div className={styles.cardHeaderChildren}>{children}</div>
      {actions && (
        <div className={styles.cardHeaderActions}>
          <SpaceBetween spacing={styles.cardHeaderSpacing}>{actions}</SpaceBetween>
        </div>
      )}
    </div>
  );
};

export interface CardBodyProps {
  className?: string;
}

export const CardBody: React.FC<CardBodyProps> = ({ className, children }) => {
  return <div className={cx(styles.cardBody, className)}>{children}</div>;
};

export interface CardFooterProps {
  className?: string;
}

export const CardFooter: React.FC<CardFooterProps> = ({ className, children }) => {
  return (
    <div className={cx(styles.cardFooter, className)}>
      <SpaceBetween spacing={styles.cardFooterSpacing}>{children}</SpaceBetween>
    </div>
  );
};

export interface CardProps {
  className?: string;
}

const Card: React.FC<CardProps> = ({ className, children }) => {
  return <div className={cx(styles.card, className)}>{children}</div>;
};

export default Card;
